<template>
  <div class="zlgl_content">
    <el-row type="flex" justify="space-around" style="width: 100%; height: 33%">
      <div class="zlgl_block">
        <img :src="imgs.img01" alt="" />
        <div class="zlgl_box">
          <span class="zlgl_desc">抽检数量</span>
          <countTo
            class="zlgl_count"
            :startVal="0"
            :endVal="form.quantityCheckNum"
            :duration="3000"
          ></countTo>
        </div>
      </div>
      <div class="zlgl_line"></div>
      <div class="zlgl_block">
        <img :src="imgs.img02" alt="" />
        <div class="zlgl_box">
          <span class="zlgl_desc">良品数量</span>
          <countTo
            class="zlgl_count"
            :startVal="0"
            :endVal="form.quantityQuanlifiedNum"
            :duration="3000"
          ></countTo>
        </div>
      </div>
      <div class="zlgl_line"></div>
      <div class="zlgl_block">
        <img :src="imgs.img03" alt="" />
        <div class="zlgl_box">
          <span class="zlgl_desc">不良品数</span>
          <countTo
            class="zlgl_count"
            :startVal="0"
            :endVal="form.quantityUnqualifiedNum"
            :duration="3000"
          ></countTo>
        </div>
      </div>
    </el-row>
    <el-row type="flex" justify="space-around" style="width: 100%; height: 67%">
      <el-col :span="12">
        <div class="zlgl_title"><span>不良品率</span></div>
        <div
          id="chart03"
          ref="chartRefPie"
          style="width: 100%; height: 110px"
        ></div>
        <div class="zlgl_desc">
          <span>订单：{{ form.orderNum }}</span>
          <span class="zlgl_desc_line"></span>
          <span>不良品数：{{ form.quantityUnqualifiedNum2 }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="zlgl_title"><span>不良品率趋势图</span></div>
        <div
          id="chart02"
          ref="chartRefLine"
          style="width: 100%; height: 130px"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import countTo from 'vue-count-to'
import { getQualityCount, getQualityRate, getQualitySingleRate } from '@/api/index'
export default {
  components: {
    countTo
  },
  data () {
    return {
      imgs: {
        img01: require('@/assets/imgs/cjsl.png'),
        img02: require('@/assets/imgs/lpsl.png'),
        img03: require('@/assets/imgs/blpsl.png'),
      },
      dataList: [
        {
          value: 55,
          name: 'AC12345678',
          itemStyle: {
            normal: {
              color: {
                colorStops: [{
                  offset: 0,
                  color: '#E6D72F' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: '#090E1C' // 100% 处的颜色
                }]
              },
            }
          }
        },
        {
          value: 35,
          name: 'AC12345679',
          itemStyle: {
            normal: {
              color: {
                colorStops: [{
                  offset: 0,
                  color: '#25A5FF' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: '#090E1C' // 100% 处的颜色
                }]
              },
            }
          }
        },
        {
          value: 40,
          name: 'AC12345542',
          itemStyle: {
            normal: {
              color: {
                colorStops: [{
                  offset: 0,
                  color: '#FF7725' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: '#090E1C' // 100% 处的颜色
                }]
              },
            }
          }
        },
        {
          value: 100,
          name: 'AC12345145',
          itemStyle: {
            normal: {
              color: {
                colorStops: [{
                  offset: 0,
                  color: '#5ADDA4' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: '#090E1C' // 100% 处的颜色
                }]
              },
            }
          }
        },
      ],
      form: {
        quantityCheckNum: 0,
        quantityQuanlifiedNum: 0,
        quantityUnqualifiedNum: 0,
        orderNum: 0,
        quantityUnqualifiedNum2: 0,
      },
      rateList: [],
      pieRateList: [],
    }
  },
  mounted () {
    this.getQualityCounts()
    this.getQualityRates()
    this.getQualitySingleRates()
    /**两个图表数据有问题 */
  },
  methods: {
    setPieCharts () {
      const theEcharts = echarts.init(this.$refs.chartRefPie, 'dark');
      const options = {
        tooltip: {
          trigger: 'item',
          formatter: "订单: {b} <br /> 不良品率: {d}%",
          backgroundColor: "rgba(0,18,34,0.8)",
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '0%',    // 去除左侧间距
          right: '0%',   // 去除右侧间距
          bottom: '0%',  // 去除底部间距
          top: '10%',     // 去除顶部间距
          containLabel: true // 如果使用 `containLabel: true`，则会根据标签大小自动调整间距，保证标签内容不被裁剪
        },
        legend: {
          orient: 'vertical',
          right: '0',
          top: 'middle',
          icon: 'circle',
          itemHeight: 12,
          textStyle: {
            color: '#fff'
          },
          formatter: (name) => {
            // formatter格式化函数动态呈现数据
            var total = 0; // 用于计算总数
            var target; // 遍历拿到数据
            for (var i = 0; i < this.dataList.length; i++) {
              total += this.dataList[i].value;
              if (this.dataList[i].name == name) {
                target = this.dataList[i].value;
              }
            }
            if (total == 0) {
              return `${name}    0%`;
            }
            var v = ((target / total) * 100).toFixed(0);
            return `${name}    ${v}%`;
          },
        },
        series: [
          {
            name: '内环',
            type: 'pie',
            silent: true,
            clockWise: true,
            hoverAnimation: false,
            animationType: 'scale',
            radius: '15%',
            center: ['30%', '50%'],
            label: {
              normal: {
                position: 'center'
              }
            },
            data: [{
              value: 100,
              itemStyle: {
                normal: {
                  color: {
                    colorStops: [{
                      offset: 0,
                      color: '#fff' // 0% 处的颜色
                    }, {
                      offset: 1,
                      color: '#cfcfcf' // 100% 处的颜色
                    }]
                  }
                }
              }
            }]
          },
          {
            name: '内环',
            type: 'pie',
            silent: true,
            clockWise: true,
            hoverAnimation: false,
            animationType: 'scale',
            radius: ['15%', '30%'],
            center: ['30%', '50%'],
            label: {
              normal: {
                position: 'center'
              }
            },
            data: [{
              value: 100,
              itemStyle: {
                normal: {
                  color: {
                    colorStops: [{
                      offset: 0,
                      color: '#5ADDA4' // 0% 处的颜色
                    }, {
                      offset: 1,
                      color: '#5ADDA4' // 100% 处的颜色
                    }]
                  }
                }
              }
            }]
          },
          {
            name: '半径模式',
            type: 'pie',
            radius: ['30%', '100%'],
            center: ['30%', '50%'],
            roseType: 'radius',
            label: {
              show: false
            },
            lableLine: {
              show: false
            },
            data: this.dataList
          }

        ]
      }
      // 渲染图表
      theEcharts.setOption(options)
    },
    setOpenCloseCharts () {
      const theEcharts = echarts.init(this.$refs.chartRefLine, 'dark');
      const options = {
        grid: {
          left: '0%',    // 去除左侧间距
          right: '0%',   // 去除右侧间距
          bottom: '0%',  // 去除底部间距
          top: '10%',     // 去除顶部间距
          containLabel: true // 如果使用 `containLabel: true`，则会根据标签大小自动调整间距，保证标签内容不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        xAxis: {
          type: 'category',
          data: this.rateList.map(item => item.currentMonth)
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
          interval: 20,
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [
          {
            data: this.rateList.map(item => item.unqualifiedRate * 100),
            type: 'line',
            areaStyle: {
              opacity: 0.3
            }
          }
        ]
      }
      // 渲染图表
      theEcharts.setOption(options)
    },

    async getQualityCounts () {
      let result = await getQualityCount({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this, 'form', result.data)
      }
    },
    async getQualityRates () {
      let result = await getQualityRate({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this.form, 'orderNum', result.data.orderNum)
        this.$set(this.form, 'quantityUnqualifiedNum2', result.data.quantityUnqualifiedNum)
        this.$set(this, 'rateList', result.data.rate)
        this.setOpenCloseCharts()
      }
    },
    async getQualitySingleRates () {
      let result = await getQualitySingleRate({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this, 'pieRateList', result.data)
        this.pieRateList.map((item, index) => {
          if (index < 4) {
            this.dataList[index].value = item.quantityRate * 100
            this.dataList[index].name = item.oqcCode
          }
        })
        this.setPieCharts()
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.zlgl_content {
  width: 100%;
  height: calc(100% - 20px);
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  .zlgl_title {
    width: 100%;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: left;
    padding-bottom: 5px;
  }
  .zlgl_desc {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    margin-top: 5px;
    color: #ffffff;
    display: flex;
    justify-content: space-around;
    .zlgl_desc_line {
      display: inline-block;
      width: 1px;
      background: #1d73b2;
    }
  }
  .zlgl_block {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .zlgl_box {
      height: 70%;
      padding-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-content: space-between;
      .zlgl_desc {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
      }
      .zlgl_count {
        font-family: DIN;
        font-weight: bold;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        animation: breathLampScale 2s alternate infinite;
      }
    }
  }
  .zlgl_line {
    width: 1px;
    height: 46px;
    background: #1d73b2;
    border: 1px dashed #25a5ff;
    opacity: 0.3;
  }
}
@keyframes breathLampScale {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0.9);
  }
}
</style>